import mapsApiKey from './mapsApiKey/mapsApiKeySlice';

const root = {
	mapsApiKey
};

export default root;
